import React, { useState } from "react"
import * as S from "./header.styles.jsx"
import { Hidden } from "@mui/material"
import CustomLink from "../custom-link/custom-link.component"

import MenuIcon from "@mui/icons-material/Menu"
import CloseIcon from "@mui/icons-material/Close"
import Fade from "@mui/material/Fade"
import FullScreenMenu from "./full-screen-menu/full-screen-menu.component"
import Box from "@mui/material/Box"
import Logo from "../../images/logo.png"
import data from "./header.json"
import Instagram from "../../assets/icons/instagram.svg"

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const handleCloseMenu = () => setIsMenuOpen(false)
  const handleToggleMenu = () => setIsMenuOpen(!isMenuOpen)

  return (
    <S.Wrapper>
      <Box className="first">
        <S.Logo>
          <CustomLink url="/">
            <img src={Logo} alt="logo" />
          </CustomLink>
        </S.Logo>
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <ul>
            {data.items.map((item, index) =>
              !item.target ? (
                <S.Item key={index}>
                  <CustomLink url={item.url}>{item.title}</CustomLink>
                </S.Item>
              ) : (
                <S.Item key={index}>
                  <a href={item.url} target={item.target}>
                    {item.title}
                  </a>
                </S.Item>
              )
            )}
          </ul>
        </Box>
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <S.Description>
            <h2>{data.restaurant.name}</h2>
            <a href={`tel:'${data.restaurant.phone}`} className="phone">
              {data.restaurant.phone}
            </a>
            <p className="address">
              {data.restaurant.address} <br />
              <span>{data.restaurant.city}</span>
            </p>
            <a className="social-media" href={data.instagram} target="_blank">
              <p>{data.restaurant.socialMedia}</p>
              <Instagram />
            </a>
          </S.Description>
        </Box>
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          <S.RightItems>
            <S.MenuBtn onClick={handleToggleMenu}>
              {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </S.MenuBtn>
          </S.RightItems>
        </Box>
      </Box>
      <Fade in={isMenuOpen} mountOnEnter unmountOnExit>
        <div>
          <FullScreenMenu handleClose={handleCloseMenu} />
        </div>
      </Fade>
    </S.Wrapper>
  )
}
export default Header
